export * from "./alert-voice.component";
export * from "./alert-voice.service";
